import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../components/Box';
import { Loader } from '../../../components/Loader';
import { Pagination } from '../../../components/Pagination';
import { selectWork, selectWorks } from '../../Api/selectors';
//import { fetchORBStock } from '../actions';
import { fetchORBStock } from '../actions';
import { FETCH_ORB_STOCK, ORB_DOMAIN } from '../constants';
import { selectORBStock } from '../selectors';
import { ORBStockItem } from './StockItem';

const Container = styled.div`
  .item-row {
    > div {
      width: 150px;
    }
    > div:first-child {
      width: 100px;
    }
    > div:nth-child(2) {
      width: 100px;
    }
  }
`;

const STATE = {
  currentPage: 0,
};

/* eslint-disable react/prefer-stateless-function */
class ORBStockComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.get();
  }

  handlePageChange = newPage => {
    this.setState({ currentPage: newPage }, this.props.get(newPage));
  };

  render() {
    if (this.props.loading) return <Loader small />;
    console.log(this.props.stock);
    return (
      <Container>
        <VBox>
          {window.innerWidth > 768 && (
            <HBox className="item-row" left>
              <div>ID</div>
              <div>Kenteken</div>
              <div>Brand/Model</div>
              <div>Type voorraad</div>
            </HBox>
          )}
          {!this.props.loading && this.props.stock?.items?.map(item => <ORBStockItem key={item.voertuigId} item={item} />)}
          {this.props.stock?.items?.length && (
            <Pagination paginator={this.props.stock?.paginator} selectPage={this.handlePageChange} />
          )}
        </VBox>
      </Container>
    );
  }
}

ORBStockComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    stock: selectORBStock(),
    loading: selectWorks([ORB_DOMAIN, FETCH_ORB_STOCK]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    get(page) {
      dispatch(fetchORBStock(page));
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const ORBStock = compose(
  withRouter,
  withConnect,
)(ORBStockComp);
